export default {
    user: null,
    loggedIn: false,
    loginError: null
};
